import { api } from "@/shared/api/baseApi";
import type { UserResponse } from "@keystone/contracts/users";

const dashboardApi = api.enhanceEndpoints({ addTagTypes: ["MyProfile"] }).injectEndpoints({
  endpoints: (build) => ({
    getMyProfile: build.query<UserResponse, void>({
      query: () => "/auth/me/profile",
      providesTags: [{ type: "MyProfile", id: "ME" }],
    }),
  }),
});

export const { useGetMyProfileQuery } = dashboardApi;
export { dashboardApi };
